import { clsx } from 'clsx';

type TTableProps = {
  columns: {
    field: string;
    headerName: string;
  }[];
  rows: {
    id: number;
    [key: string]: string | number;
  }[];
  hideHeader?: boolean;
  /** When true, the first column's <td> cells render bold (for key-value tables). */
  boldFirstColumn?: boolean;
};

const tableBorderClassname = ' border-solid border-base-dark';

export const Table: React.FC<React.PropsWithChildren<TTableProps>> = ({
  columns,
  rows,
  hideHeader = false,
  boldFirstColumn = false,
}) => {
  return (
    <table className={clsx(tableBorderClassname, 'mb-16')}>
      {!hideHeader && (
        <thead>
          <tr>
            {columns.map(column => (
              <th
                key={column.field}
                className="border border-solid border-white p-8 bg-primary-main text-white"
              >
                {column.headerName}
              </th>
            ))}
          </tr>
        </thead>
      )}
      <tbody>
        {rows.map(row => (
          <tr key={row.id}>
            {columns.map((column, colIndex) => {
              let value = row[column.field];

              if (!value && process.env.NODE_ENV === 'development') {
                console.warn(
                  `The row: "${JSON.stringify(
                    row,
                  )}" doesn't contains the value ${column.field}`,
                );
                value = 'not-defined';
              }

              // In headerless key-value tables (boldFirstColumn) the first
              // column is the row's label — render it as <th scope="row"> so
              // screen readers keep the row-header association, not just bold text.
              if (boldFirstColumn && colIndex === 0) {
                return (
                  <th
                    key={`${row.id}-${column.field}`}
                    scope="row"
                    className={clsx(
                      tableBorderClassname,
                      'border p-8 font-semibold',
                    )}
                    dangerouslySetInnerHTML={{
                      __html: value.toString(),
                    }}
                  />
                );
              }

              return (
                <td
                  key={`${row.id}-${column.field}`}
                  className={clsx(tableBorderClassname, 'border p-8')}
                  dangerouslySetInnerHTML={{
                    __html: value.toString(),
                  }}
                />
              );
            })}
          </tr>
        ))}
      </tbody>
    </table>
  );
};

export default Table;
